<template>
  <div class="wrapper">
    <div class="body">
      <div class="col-12">
        <div v-if="!loading">
          <div class="row">
            <div class="col-3">
              <div class="search-swot">
                <input
                  type="text"
                  class="form-control"
                  id="input-action"
                  :placeholder="$t('aiReports.searchInput')"
                  v-model="filter"
                  @keyup="searchByFilter"
                />
                <button @click="cleanFilter" class="btn btn-outline-primary">
                  {{ $t('aiReports.searchButton') }}
                </button>
              </div>
            </div>
            <div class="button-new-swot">

              <button
                class="btn btn-new-analysis"
                v-b-modal="`modal-new-aireport`"
              >
                {{ $t('aiReports.newAnalysis') }}
              </button>
              <modal-new-aireport :modalType = 'modalType'/>
            </div>
          </div>
          <div class="row">
            <div class="col-12">
              <b-table
                striped
                responsive
                id="table"
                class="mt-4"
                style="overflow: inherit"
                :items="items"
                :fields="fields"
                no-local-sorting
                :busy="loading"
              >
                <template v-slot:cell(status)="row">
                  <div
                    :class="`flag-status flag-status-${row.item.status}`"
                  >
                    {{ $t(`aiReports.swotTable.status.${row.item.status}`) }}
                  </div>
                </template>
                <template v-slot:cell(visualization)="row">
                  <span class="table-icons">
                    <a @click="$router.push(`/swot-view/${row.item._id}`)">
                      <font-awesome-icon :icon="['fas', 'eye']" />
                    </a>
                  </span>
                </template>
              </b-table>
            </div>
          </div>
        </div>
        <div v-else class="loader">
          <b-spinner
            variant="primary"
            type="grow"
            :label="`${this.$t('reports.loadingLabel')}...`"
          ></b-spinner>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState } from 'vuex';
// import api from '../../../../../../services/api';
import ModalNewAireport from '@/components/organisms/reports/ai-analysis/modal-new-aireport';

export default {
  components: {
    ModalNewAireport,
  },
  data: () => ({
    loading: false,
    userAuth: null,
    items: [],
    fields: [],
    filter: null,
    typingTimer: null,
    page: 1,
    limit: 10,
    modalType: 'SWOT',
  }),

  computed: {
    ...mapState('actions', ['myActionId', 'actionGroupData', 'myActionsIds']),
    ...mapState('branches', [
      'myIh1',
      'myIh2',
      'myHierarchies1',
      'myHierarchies2',
    ]),
    ...mapState('calendar', ['calendarDates']),
    ...mapState('companies', ['myMetric']),
  },

  watch: {
    actionGroupData: function watchActionGroup() {
      this.updateTable();
    },
    myActionId: function watchMyActionId() {
      this.updateTable();
    },
    myActionsIds: function watchMyActionsIds() {
      this.updateTable();
    },
    myIh1: function watchMyIh1() {
      this.updateTable();
    },
    myHierarchies1: function watchMyHierarchies1() {
      this.updateTable();
    },
    myIh2: function watchMyIh2() {
      this.updateTable();
    },
    myHierarchies2: function watchMyHierarchies2() {
      this.updateTable();
    },
    calendarDates: function watchDates() {
      this.updateTable();
    },
    myMetric: function watchMyMetric() {
      this.updateTable();
    },
    'indicatorData.value': function watchIndicatorData() {
      this.updateTable();
    },
    'indicatorData.period': function watchIndicatorPeriod() {
      this.updateTable();
    },
    '$i18n.locale': function watchLocale() {
      this.updateTable();
    },
  },

  methods: {
    async updateTable() {
      this.loading = true;
      /*
      // call internal API for getting SWOT table information
      const response = await api.get(`swots/${this.userAuth.companyId}`, {
        params: {
          page: this.page,
          limit: this.limit,
          filter: this.filter,
        },
        headers: {
          'x-access-token': this.userAuth.token,
        },
      });
      */

      this.loading = false;
    },

    updateTranslate() {
    },

    searchByFilter() {
      if (this.filter !== '' && this.filter !== null) {
        this.page = 1;
        clearTimeout(this.typingTimer);
        this.typingTimer = setTimeout(this.updateTable, 600);
      }

      if (this.filter === '') {
        this.filter = null;
        this.page = 1;
        this.updateTable();
      }
    },

    cleanFilter() {
      this.filter = null;
      this.updateTable();
    },

  },

  async mounted() {
    await this.updateTable();
    this.updateTranslate();
  },

  created() {
    this.userAuth = JSON.parse(localStorage.getItem('_indecx'));
    this.fields = [
      { key: 'controlId', label: this.$t('aiReports.swotTable.labels.id') },
      {
        key: 'filters',
        label: this.$t('aiReports.swotTable.labels.filters'),
      },
      {
        key: 'createdAt',
        label: this.$t('aiReports.swotTable.labels.createdAt'),
      },
      {
        key: 'period',
        label: this.$t('aiReports.swotTable.labels.period'),
      },
      {
        key: 'qtd',
        label: this.$t('aiReports.swotTable.labels.qtd'),
      },
      {
        key: 'status',
        label: this.$t('aiReports.swotTable.labels.status'),
      },
      {
        key: 'visualization',
        label: this.$t('aiReports.swotTable.labels.visualization'),
        class: 'center-icon',
      },
    ];
    this.items = [
      {
        _id: '12345-12345-12345-12345',
        controlId: 'NIKOOJ',
        filters: 'Ações: Pós-vendas, Testes IA, Usabilidade App; Filiais: SP, CE; Indicadores: APP',
        createdAt: '15/09/2023',
        period: 'Últimos 30 dias',
        qtd: '3957',
        status: 'processado',
      },
      {
        _id: '12345-12345-12345-12345',
        controlId: 'NIKOOJ',
        filters: 'Ações: Usabilidade App; Filiais: SP; Indicadores: Contas Inativas',
        createdAt: '15/09/2023',
        period: 'Ano atual',
        qtd: '35070',
        status: 'processando',
      },
      {
        _id: '12345-12345-12345-12345',
        controlId: 'NIKOOJ',
        filters: 'Ações: Lançamento; Filiais: SP, CE; Indicadores: APP',
        createdAt: '15/09/2023',
        period: 'Últimos 7 dias',
        qtd: '357',
        status: 'falha',
      },
    ]
  },
};
</script>

<style lang="scss" scoped>
@import '@/themes/default/variables.scss';
.align-header {
  display: flex;
  justify-content: space-between;
}
.wrapper {
  padding: 8px;
  padding-top: 0px;
  padding-right: 13px;
}
.body {
  background-color: $white;
  padding: 16px;
  border: 1px solid $gray-light;
  border-radius: 4px;
}
.body h2 {
  text-transform: uppercase;
  font-size: 21px;
  font-weight: 100;
  color: $gray;
}
.header {
  display: flex;
  flex-direction: row;

  .header-icon {
    float: left;
    font-size: 12px;
    margin-top: 4px;
    padding-right: 12px;
    color: $gray;
  }
}
.search-swot {
  display: flex;
  flex-direction: row;

  input {
    border-bottom-right-radius: 0;
    border-top-right-radius: 0;
  }

  button {
    border-bottom-left-radius: 0;
    border-top-left-radius: 0;
  }
}
.button-new-swot {
  position: absolute;
  right: 20px;
}
.btn-new-analysis {
  color: white;
  background: #3DB374;
}
.flag-status {
  display: flex;
  width: 120px;
  padding: 2px 12px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
  border-radius: 4px;
  color: white;
}
.flag-status-processando {
  background: #BABABA;
}
.flag-status-processado {
  background: #37E688; 
}
.flag-status-falha {
  background: #E1513D;
}
.table-icons {
  color: #3DB374;
  width: 18px;
  height: 18px;
  flex-shrink: 0;
}
</style>
<style lang="scss">
.center-icon {
  text-align: center !important;
  cursor: pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/organisms/reports/ai-analysis/ai-swot-reports/swot/index.vue